import { useEffect, useState } from "react";
import { Mail, Send, X } from "lucide-react";
import { http, formatApiError } from "../../lib/api";
import { toast } from "../../lib/notify";
import { BANK_CONTACTS, BTN_DARK, BTN_LIGHT } from "./finConst";

// Banka kartından alıcı seç → sunucu seçili dosyaları ek olarak gönderir (bilgi: yönetici/finans/muhasebe)
export default function BankMailDialog({ title, summary, onSend, onClose }) {
  const [banks, setBanks] = useState([]);
  const [bankId, setBankId] = useState("");
  const [contacts, setContacts] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { http.get("/banks").then((r) => setBanks(r.data)).catch(() => {}); }, []);
  const bank = banks.find((b) => b.id === bankId);
  const avail = BANK_CONTACTS.filter(([, , , emailKey]) => bank?.[emailKey]);
  useEffect(() => { setContacts(avail.map(([k]) => k)); }, [bankId]); // eslint-disable-line react-hooks/exhaustive-deps
  const send = async () => {
    if (!bankId || !contacts.length) { toast.error("Banka ve en az bir alıcı seçin"); return; }
    setBusy(true);
    try {
      const res = await onSend({ bank_id: bankId, contacts });
      toast.success(`Gönderildi → ${res.results.map((r) => r.to).join(", ")}${res.cc?.length ? ` (bilgi: ${res.cc.length} kişi)` : ""}`);
      onClose();
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/40 flex items-center justify-center p-4" onClick={onClose} data-testid="bank-mail-dialog">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg p-5 space-y-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3">
          <div><div className="text-sm font-bold text-slate-900 inline-flex items-center gap-2"><Mail className="w-4 h-4 text-amber-600" /> {title}</div><div className="text-xs text-slate-500 mt-1">{summary}</div></div>
          <button type="button" onClick={onClose} className="p-1 rounded hover:bg-slate-100" data-testid="bank-mail-close"><X className="w-4 h-4" /></button>
        </div>
        <label className="block text-[10px] font-semibold uppercase tracking-wider text-slate-500">Banka Kartı
          <select value={bankId} onChange={(e) => setBankId(e.target.value)} className="mt-1 w-full px-2.5 py-2 text-sm border border-slate-300 rounded-md bg-white" data-testid="bank-mail-bank">
            <option value="">Seçiniz…</option>
            {banks.map((b) => <option key={b.id} value={b.id}>{[b.name, b.branch, b.company].filter(Boolean).join(" · ")}</option>)}
          </select>
        </label>
        {bank && (
          <div className="space-y-1.5" data-testid="bank-mail-contacts">
            <div className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">Alıcılar</div>
            {avail.length === 0 && <div className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-2 py-1.5">Bu banka kartında e-posta adresi yok — Banka Kartları sekmesinden ekleyin.</div>}
            {avail.map(([k, label, nameKey, emailKey]) => (
              <label key={k} className="flex items-center gap-2 text-xs cursor-pointer">
                <input type="checkbox" checked={contacts.includes(k)} onChange={() => setContacts(contacts.includes(k) ? contacts.filter((x) => x !== k) : [...contacts, k])} data-testid={`bank-mail-contact-${k}`} />
                <span className="font-semibold text-slate-700">{label}</span>{nameKey && bank[nameKey] && <span>{bank[nameKey]}</span>}<span className="text-sky-700" data-no-upper>{bank[emailKey]}</span>
              </label>
            ))}
          </div>
        )}
        <div className="text-[11px] text-slate-500 bg-slate-50 rounded-md px-3 py-2">Konu: <b>{title === "Bankaya Mail Gönder" ? "MALİ VERİ TALEBİ HK." : "ŞİRKET EVRAKLARI HK."}</b> · Metin: "Sayın Yetkili, … mail ekindedir." · Bilgi: yönetici, finans ve muhasebe e-postaları.</div>
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className={BTN_LIGHT}>İptal</button>
          <button type="button" onClick={send} disabled={busy || !bankId || !contacts.length} className={BTN_DARK} data-testid="bank-mail-send"><Send className="w-3.5 h-3.5" /> {busy ? "Gönderiliyor…" : "Gönder"}</button>
        </div>
      </div>
    </div>
  );
}
